// Spacing
export var spacing = {
  s1: "0.125rem",
  s2: "0.25rem",
  s3: "0.5rem",
  s4: "0.75rem",
  s5: "1rem",
  s6: "1.25rem",
  s7: "1.5rem",
  s8: "2rem",
  s9: "2.25rem",
  s10: "2.5rem"
};